import React from 'react';
import { FaUser, FaSignOutAlt, FaMapMarkerAlt, FaBuilding, FaBars } from 'react-icons/fa';
import NotificationBell from '../../components/NotificationBell';
import { useNotifications } from '../../hooks/useNotifications';

const Header = ({ userInfo, onLogout, title, toggleSidebar, onOpenChat, onOpenSupport }) => {
  // Detect screen width to conditionally show hamburger icon and simplify layout
  const [isMobile, setIsMobile] = React.useState(false);
  const {
    totalCount,
    messageCount,
    supportTicketCount,
    loading,
    refreshCounts
  } = useNotifications(userInfo);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header style={{
      display: 'flex',
      justifyContent: isMobile ? 'space-between' : 'space-between',
      alignItems: 'center',
      padding: '20px 10px',
      borderBottom: '2px solid #e0e0e0',
      marginBottom: 20,
      backgroundColor: '#fff',
      borderRadius: 8,
      paddingLeft: 20,
      paddingRight: 20,
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        {isMobile && (
          <button
            onClick={toggleSidebar}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              marginRight: '1rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.5rem',
              color: '#1976d2'
            }}
            aria-label="Toggle sidebar"
          >
            <FaBars />
          </button>
        )}
        {!isMobile && (
          <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: '600' }}>
            {title}
          </h1>
        )}
      </div>

      {!isMobile && userInfo && (
        <div style={{
          fontSize: '0.9rem',
          opacity: 0.8,
          marginTop: '0.25rem',
          display: 'flex',
          alignItems: 'center',
          gap: '1rem'
        }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <FaBuilding size={12} />
            {userInfo.mmda_name || 'MMDA'}
          </span>
          <span style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            color: userInfo.zone_id ? 'inherit' : '#e74c3c'
          }}>
            <FaMapMarkerAlt size={12} />
            Zone: {userInfo.zone_name || 'No Zone Assigned'}
          </span>
        </div>
      )}

      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        {userInfo && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 1rem',
            backgroundColor: 'rgba(255,255,255,0.1)',
            borderRadius: '0.5rem'
          }}>
            <FaUser size={16} />
            <div>
              <div style={{ fontWeight: '500', fontSize: '0.9rem' }}>
                {userInfo.full_name || userInfo.name}
              </div>
              {!isMobile && (
                <div style={{ fontSize: '0.75rem', opacity: 0.8 }}>
                  {userInfo.roleName || 'Revenue Officer'}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Notification Bell */}
        <NotificationBell
          notificationCount={totalCount}
          messageCount={messageCount}
          supportTicketCount={supportTicketCount}
          onClick={refreshCounts}
          onOpenChat={onOpenChat}
          onOpenSupport={onOpenSupport}
          onRefresh={refreshCounts}
          loading={loading}
          size={isMobile ? 18 : 22}
          style={{
            marginRight: isMobile ? '0.5rem' : '1rem'
          }}
        />

        <button
          onClick={onLogout}
          style={{
            backgroundColor: '#e74c3c',
            color: 'white',
            border: 'none',
            padding: '0.5rem 1rem',
            borderRadius: '0.5rem',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            fontSize: '0.9rem',
            transition: 'background-color 0.2s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#c0392b'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#e74c3c'}
        >
          <FaSignOutAlt size={14} />
          {!isMobile && 'Logout'}
        </button>
      </div>
    </header>
  );
};

export default Header;
